import type {ReactAction} from '@netx/core/bootstrap';

export const actionsToOrderedActions = (
	actions: ReactAction[],
): Array<ReactAction | ReactAction[]> => {
	const groups = actions
		.reduce<ReactAction[][]>((groups, action) => {
			const group = action.group || 0;
			const actionGroup = (groups[group] = groups[group] || []);
			actionGroup.push(action);
			return groups;
		}, [])
		.filter((group) => group)
		.map((actionGroup) => {
			actionGroup.sort((a, b) => a.label.localeCompare(b.label));

			const splitActions = actionGroup.reduce(
				(splitActions, action) => ({
					ordered:
						action.order != null
							? [...splitActions.ordered, action]
							: splitActions.ordered,
					unordered:
						action.order == null
							? [...splitActions.unordered, action]
							: splitActions.unordered,
				}),
				{
					ordered: [] as ReactAction[],
					unordered: [] as ReactAction[],
				},
			);
			return [
				...splitActions.ordered.sort((a, b) => a.order! - b.order!),
				...splitActions.unordered,
			];
		});

	return groups.length === 1 ? groups[0] : groups;
};

export default actionsToOrderedActions;
